import { useState } from "react";

import { useAuthenticationManager } from "scenes/Authentication/hooks/useAuthenticationManager";

export function useForgotPasswordForm(onDone = () => {}) {
  const { forgotPassword, isProcessing } = useAuthenticationManager();
  const [error, setError] = useState();

  return {
    loading: isProcessing,
    error: error,
    forgot: async ({ email }) => {
      setError("");
      try {
        await forgotPassword(email);
        onDone(email);
      } catch (err) {
        setError(err?.message || "Failed to send verification code.");
      }
    },
  };
}

export default useForgotPasswordForm;
